var $ = require("jquery");
require("slick-carousel/slick/slick.scss");
require("slick-carousel");

$(document).ready(() => {
  const nextArrow = `
  <button type="button" class="text-gray-800 z-20 h-15 w-15 bg-yellow-400 rounded-full hover:text-yellow-400 hover:bg-gray-800 transition-colors absolute top-33 lg:top-46 -right-2 lg:right-20">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.4538 11.8009L17.4537 11.801L17.4575 11.8102C17.5075 11.9319 17.5075 12.0685 17.4575 12.1902L17.4574 12.1901L17.4538 12.1994C17.4306 12.2594 17.396 12.3143 17.3519 12.3612L12.3564 17.3566L12.355 17.3581C12.3085 17.405 12.2532 17.4421 12.1923 17.4675C12.1314 17.4929 12.066 17.506 12 17.506C11.934 17.506 11.8686 17.4929 11.8077 17.4675C11.7468 17.4421 11.6915 17.405 11.645 17.3581L11.6421 17.3552C11.5952 17.3087 11.558 17.2534 11.5327 17.1925C11.5073 17.1315 11.4942 17.0662 11.4942 17.0002C11.4942 16.9342 11.5073 16.8688 11.5327 16.8079C11.558 16.747 11.5952 16.6917 11.6421 16.6452L11.643 16.6443L14.943 13.3543L15.7997 12.5002H14.59H7C6.86739 12.5002 6.74022 12.4475 6.64645 12.3537C6.55268 12.26 6.5 12.1328 6.5 12.0002C6.5 11.8676 6.55268 11.7404 6.64645 11.6466C6.74022 11.5529 6.86739 11.5002 7 11.5002H14.59H15.7997L14.943 10.6461L11.6436 7.35663C11.6435 7.35658 11.6434 7.35653 11.6434 7.35647C11.549 7.26195 11.4959 7.1338 11.4959 7.00019C11.4959 6.93399 11.5089 6.86844 11.5343 6.80728C11.5596 6.74612 11.5967 6.69055 11.6436 6.64374C11.7381 6.5492 11.8663 6.49609 12 6.49609C12.0662 6.49609 12.1317 6.50913 12.1929 6.53447C12.2541 6.5598 12.3096 6.59693 12.3564 6.64374L12.7083 6.29188L12.3564 6.64374L17.3519 11.6392C17.396 11.6861 17.4306 11.741 17.4538 11.8009Z" fill="black" stroke="currentColor"/>
    </svg>
  </button>`;

  const prevArrow = `
  <button type="button" class="text-gray-800 z-20 h-15 w-15 bg-yellow-400 rounded-full hover:text-yellow-400 hover:bg-gray-800 transition-colors rotate-180 absolute top-33 lg:top-46 -left-2 lg:left-20">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.4538 11.8009L17.4537 11.801L17.4575 11.8102C17.5075 11.9319 17.5075 12.0685 17.4575 12.1902L17.4574 12.1901L17.4538 12.1994C17.4306 12.2594 17.396 12.3143 17.3519 12.3612L12.3564 17.3566L12.355 17.3581C12.3085 17.405 12.2532 17.4421 12.1923 17.4675C12.1314 17.4929 12.066 17.506 12 17.506C11.934 17.506 11.8686 17.4929 11.8077 17.4675C11.7468 17.4421 11.6915 17.405 11.645 17.3581L11.6421 17.3552C11.5952 17.3087 11.558 17.2534 11.5327 17.1925C11.5073 17.1315 11.4942 17.0662 11.4942 17.0002C11.4942 16.9342 11.5073 16.8688 11.5327 16.8079C11.558 16.747 11.5952 16.6917 11.6421 16.6452L11.643 16.6443L14.943 13.3543L15.7997 12.5002H14.59H7C6.86739 12.5002 6.74022 12.4475 6.64645 12.3537C6.55268 12.26 6.5 12.1328 6.5 12.0002C6.5 11.8676 6.55268 11.7404 6.64645 11.6466C6.74022 11.5529 6.86739 11.5002 7 11.5002H14.59H15.7997L14.943 10.6461L11.6436 7.35663C11.6435 7.35658 11.6434 7.35653 11.6434 7.35647C11.549 7.26195 11.4959 7.1338 11.4959 7.00019C11.4959 6.93399 11.5089 6.86844 11.5343 6.80728C11.5596 6.74612 11.5967 6.69055 11.6436 6.64374C11.7381 6.5492 11.8663 6.49609 12 6.49609C12.0662 6.49609 12.1317 6.50913 12.1929 6.53447C12.2541 6.5598 12.3096 6.59693 12.3564 6.64374L12.7083 6.29188L12.3564 6.64374L17.3519 11.6392C17.396 11.6861 17.4306 11.741 17.4538 11.8009Z" fill="black" stroke="currentColor"/>
    </svg>
  </button>`;

  $("#project-carousel").slick({
    centerMode: true,
    slidesToShow: 1,
    infinite: true,
    lazyLoad: "ondemand",
    focusOnSelect: true,
    variableWidth: true,
    dots: true,
    nextArrow: nextArrow,
    prevArrow: prevArrow,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          variableWidth: false,
          slidesToShow: 1.05
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          dots: true,
          centerMode: false,
          variableWidth: false,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 1024,
        settings: {
          arrows: true,
          dots: true
        }
      }
    ]
  });
});
